// extracted by mini-css-extract-plugin
export default {"btns":"Edit_btns__bM-Az","tabs":"Edit_tabs__qMJwz","top":"Edit_top__X9zl6","topTags":"Edit_topTags__dCdCN","hint":"Edit_hint__IoHcP","title":"Edit_title__3P1So"};